export class Defaults {
  static readonly dateFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'UTC'
  } as Intl.DateTimeFormatOptions;

  static readonly blurString = 'blur';
  static readonly dateFormatString = 'MM/dd/yyyy';
  static readonly dateFormatStringUI = 'MM/DD/YYYY';
  static readonly dateRegex = new RegExp('^(0[1-9]|1[0-2])/(0[1-9]|[12][0-9]|3[01])/\\d{4}$');
  static readonly contactUsNumber = '1-866-216-7708';
  static readonly ladEmail = 'LADSERVICE@symetra.com';
  static readonly sentinelValue = -1;
  static readonly separator = '/';
  static readonly stringEmpty = '';

  static readonly dateDefault = new Date(0);

/*   static readonly symetraDateTimeEnhancedDefault = {
    dateTime: undefined,
    unixMilliseconds: '0'
  } as SymetraDateTimeEnhanced; */

  static readonly usLocale = 'en-US';

/*   static readonly spanInfoEnhancedDefault = {
    begin: Defaults.symetraDateTimeEnhancedDefault,
    end: Defaults.symetraDateTimeEnhancedDefault
  } as SpanInfoEnhanced; */
}
